var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Is,{tag:"component",attrs:{"value":_vm.value,"config":_vm.config,"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }